import React from 'react'
import Fragment from '../common/fragment'

function FragmentDR(props) {
  return (
    <Fragment pos="rrrr" {...props}>
      <p>
      El color es un misterio. La ausencia de color es un misterio. El misterio es un color.
      </p>
    </Fragment>
  )
}


export default FragmentDR
